<template>
    <section>
        <hr>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>Local do ocorrido</label>
                    <input type="text" class="form-control form-control-sm" v-model="denuncia.local" readonly>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Tipo de denúncia</label>
                    <input type="text" class="form-control form-control-sm" v-model="denuncia.type" readonly>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Data</label>
                    <input type="date" class="form-control form-control-sm" v-model="denuncia.data" readonly>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Hora</label>
                    <input type="time" class="form-control form-control-sm" v-model="denuncia.hora" readonly>
                </div>
            </div>
        </div>

        <hr>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Comentários adicionais <span class="obrigatorio">*</span></label>
                    <textarea cols="100" rows="10" class=form-control v-model="complemento"></textarea>
                </div>
            </div>
        </div>

        <transition mode="out-in" name="leftIn">
            <div v-if="attachments[0]" class="row">
                <div class="col-12">
                    <p><strong>Anexos</strong></p>
                </div>

                <div v-for="(file, index) in attachments" :key="index" class="col-12">
                    <div class="d-flex justify-content-between">
                        <p class="p-1">{{ file.name }}</p>

                        <span class="p-1 pointer" @click="rm_file(index)">
                            <font-awesome-icon icon="times" />
                        </span>
                    </div>
                </div>
            </div>
        </transition>

        <input type="file" @change="add_file" id="files" class="hidden" multiple>
        <modal-alert :message="alert_message" @close="close_modal" />
        <modal-confirm :message="confirm_message" @response="confirm_response" />
    </section>
</template>

<script>
    import api from '@/mixins/api.js'

    export default {
        name: 'complemento',
        props: ['denuncia'],
        mixins: [ api ],

        data() { return {
            confirm_message: "",
            alert_message: "",
            type_den: [],

            complemento: "",
            attachments: [],
        }},

        methods: {
            async submit() {
                if ( this.complemento ) this.submit_complemento()

                else {
                    this.alert_message = "Preencha os campos obrigatórios!"
                    $("#modal-alert").modal()
                }
            },

            async submit_complemento() {
                const response = await this.POST( "Webform/Complemento", { complemento: this.complemento, denuncia_id: this.denuncia.id } )

                if ( response.status === 'success' ) {
                    await this.submit_attachments(response.result.id)
                    this.alert_message = "Complemento inserido com sucesso."
                    $("#modal-alert").modal()
                }

                else {
                    this.alert_message = response
                    $("#modal-alert").modal()
                }
            },

            async submit_attachments(comp) {
                this.attachments.forEach( async file => {
                    let body = new FormData()
                    body.append('attachment', file)
                    body.append('nome', file.name)
                    body.append('type', file.type)
                    
                    const response = await this.POST(`Webform/Attachment/${comp}?comp=true`, body)
                })
            },

            close_modal() {
                this.confirm_response(1)
                this.$emit('success')
            },

            add_file(event) {
                const files = Array.from(event.target.files)
                files.forEach(element => this.attachments.push(element) )
            },

            rm_file(payload) {
                this.attachments.splice(payload, 1)
            },

            clear_form() {
                this.confirm_message = "Isto limpará os dados inseridos no formulário. Continuar?"
                $("#modal-confirm").modal()
            },

            confirm_response(response) {
                if ( response === 1) {
                    this.complemento = {}
                    this.attachments = []
                }
            },
        }
    }
</script>

<style>
    .obrigatorio {
        color: brown;
    }
</style>